import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"

import Spinner from "../../../Components/Loading/Spinner";



export default function SalesByRep({  }) {
    const { user } = useAuthContext();
    const [salesByRep, setSalesByRep] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/stats/salesbyrep`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    console.log("response:", res.data);
                    setSalesByRep(res.data);
                }
            })
    }, [])

    const styles = {


        borderBox: {
            borderTop: "1px solid #A6A6A6",
            borderLeft: "1px solid #A6A6A6",
            borderRight: "1px solid #A6A6A6",
            borderBottom: "1px solid #A6A6A6",
            padding: 5
        },



    }


    return (
        <>
        {  loading && (<Spinner />)}
        { !loading && (
                <div style={{ marginBottom: 40 }}>
                    <h3>Sales By Rep (Submitted - Last 30 Days)</h3>

                    <div style={styles.borderBox}>
                        <table width="100%">
                            <thead>
                                <tr>
                                    <td>Rep</td>
                                    <td style={{ textAlign: "right" }}>Orders</td>
                                    <td style={{ textAlign: "right" }}>Value</td>
                                    <td style={{ textAlign: "right" }}>Net Contrib.</td>
                                    <td style={{ textAlign: "right" }}>Commission</td>
                                </tr>
                            </thead>
                            <tbody>
                                {salesByRep && salesByRep.map((rep, index) => (



                                    <tr>
                                        <td>{rep.name}</td>
                                        <td style={{ textAlign: "right" }}>{rep.sales}</td>
                                        <td style={{ textAlign: "right" }}>&pound;{rep.revenue.toFixed()}</td>
                                        <td style={{ textAlign: "right" }}>&pound;{rep.netContribution.toFixed()}</td>
                                        <td style={{ textAlign: "right" }}>&pound;{rep.commission.toFixed()}</td>
                                    </tr>
                                ))}
                                
                            </tbody>
                        </table>
                    </div>

                </div>)
            }
        </>
    )
}
